import template from './fiEventTemplate.html';

function eventDirective() {
    return {
    restrict: 'E',
    transclude: true,
    scope: {
        event: '='
    },
    controller: ['$scope', 'Restangular', 'notification', '$translate', function EventController($scope, Restangular, notification, $translate) {

        Restangular.one('events', $scope.event.id)
            .all('exercises').getList().then(function(eventExercises) {
                eventExercises = eventExercises.data || eventExercises;
                $scope.eventExercises = eventExercises;
            });

        $scope.properties =
            Restangular.all('properties').getList({
                filters: {
                    activity_id: $scope.event.activity_id
                },
                sort_by: 'position',
                direction: 'asc'
            }).$object;

        // Used to store the request status for every event exercise and property
        $scope.status = {};

        $scope.evaluationChange = function(eventExercise, propertyId) {
            var resource =
                    Restangular.one('events', $scope.event.id)
                            .one('exercises', eventExercise.id);

            if (Object.values) {
                resource.value_ids = Object.values(eventExercise.evaluations);
            } else {
                /*
                 * TODO: Object.values was included in Chrome 54 (Nov. 2016)
                 * We need to decide on how to support old browsers and new
                 * features of the language.
                 * https://trello.com/c/kvnxjgZb/92-decide-on-support-for-old-browsers-and-new-features-of-the-language
                 */
                resource.value_ids = [];
                for (var propId in eventExercise.evaluations) {
                    if (eventExercise.evaluations.hasOwnProperty(propId)) {
                        resource.value_ids.push(eventExercise.evaluations[propId]);
                    }
                }
            }

            $scope.progressStyle = {background: 'grey'};
            if (!$scope.status[eventExercise.id]) {
                $scope.status[eventExercise.id] = {};
            }
            $scope.status[eventExercise.id][propertyId] = 'saving';
            resource.put().then(
                function() {
                    $scope.status[eventExercise.id][propertyId] = 'success';
                },
                function(req) {
                    $scope.status[eventExercise.id][propertyId] = 'error';
                    $translate('ERROR_SAVING_EVALUATIONS', {status: req.status})
                        .then(function(message) {
                            notification.log(message, { addnCls: 'humane-flatty-error' });
                        });
                });
        };

        $scope.evaluate = function() {

        };
    }],
    template: template
  };
}
export default eventDirective;



// WEBPACK FOOTER //
// ./js/events/fiEvent.js